import Vue from "vue";
import * as mutationTypes from "../mutation-types";

//initial state
const state = {
	persistedData: {
		catalogs: {},
		lastLocaleUsed: "",
		lastLocaleUsedAdmin: "",
		allTenantLanguages: [],
		languages: {},
		dynamicCatalogs: {}
	}
};

//getters
const getters = {
	tenantLocales: state => Object.keys(state.persistedData.languages || {}),
	catalogs: state => state.persistedData.catalogs,
	specificCatalog: state => locale => state.persistedData.catalogs[locale] || {},
	lastLocale: state => state.persistedData.lastLocaleUsed,
	lastLocaleAdmin: state => state.persistedData.lastLocaleUsedAdmin,
	allTenantLanguages: state => state.persistedData.allTenantLanguages,
	languages: state => state.persistedData.languages,
	specificLanguage: state => locale => state.persistedData.languages[locale],
	dynamicCatalog: state => locale => state.persistedData.dynamicCatalogs[locale] || {}
};

//actions
const actions = {
	// async disableLanguage({ commit }, { languageCode }) {
	// 	console.log(languageCode, "LNGC");
	// 	Promise.all([
	// 		commit(mutationTypes.REMOVE_LANGUAGE, languageCode),
	// 		commit(mutationTypes.REMOVE_CATALOG, languageCode),
	// 	]);
	// },
	// async enableLanguage({ commit }, { payload }) {
	// 	console.log(payload);
	// 	Promise.all([
	// 		commit(mutationTypes.ADD_CATALOG, payload),
	// 		commit(mutationTypes.ADD_LANGUAGE, payload)
	// 	]);
	// }
};

//mutations
const mutations = {
	[mutationTypes.ADD_CATALOG](state, payload){
		Vue.set(state.persistedData.catalogs, payload[0], payload[1]);
	},
	[mutationTypes.ALL_TENANT_LANGUAGES](state, payload) {
		Vue.set(state.persistedData, "allTenantLanguages", payload);
	},
	[mutationTypes.ADD_LANGUAGE](state, payload) {
		Vue.set(state.persistedData.languages, payload[0], payload[1]);
	},
	[mutationTypes.ADD_LANGUAGES](state, payload) {
		payload.forEach(element => {
			const locale = element["languageCode"];
			const language = element["language"];
			Vue.set(state.persistedData.languages, locale, language);
		});
	},
	[mutationTypes.CLEAR_LOCALIZATION_CACHE](state) {
		Vue.set(state.persistedData, "catalogs", {});
		Vue.set(state.persistedData, "languages", {});
		Vue.set(state.persistedData, "dynamicCatalogs", {});
	},
	[mutationTypes.SET_LAST_LOCALE](state, locale) {
		Vue.set(state.persistedData, "lastLocaleUsed", locale);
	},
	[mutationTypes.SET_LAST_LOCALE_ADMIN](state, locale) {
		Vue.set(state.persistedData, "lastLocaleUsedAdmin", locale);
	},
	[mutationTypes.REMOVE_CATALOG](state, locale) {
		Vue.delete(state.persistedData.catalogs, locale);
	},
	[mutationTypes.REMOVE_LANGUAGE](state, locale){
		Vue.delete(state.persistedData.languages, locale);
	},
	[mutationTypes.SET_DYNAMIC_CATALOG](state, payload) {
		const dynamicCatalog = {...state.persistedData.dynamicCatalogs};
		dynamicCatalog[payload[0]] = payload[1];
		Vue.set(state.persistedData, "dynamicCatalogs", dynamicCatalog);
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
